import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { PageCard } from '@/components/ui/page-card'
import { Text } from '@/components/ui/text'
import { commonSearchSchema, generateTitle } from '@/lib/utils'

export const Route = createFileRoute('/_auth/success')({
  validateSearch: commonSearchSchema.extend({
    // The flow that just finished (an AuthFlow kind); see completedSearch.
    completed: z.enum(['account', 'handoff', 'guestUpgrade']).optional(),
  }),
  component: Success,
  head: () => ({ meta: [{ title: generateTitle('Authorization Complete') }] }),
})

function Success() {
  const { completed, gameId } = Route.useSearch()

  return (
    <PageCard
      title={completed === 'guestUpgrade' ? 'Guest Progress Saved' : 'Authorization Complete'}
      description={
        completed === 'guestUpgrade' ? (
          <>
            Your guest progress in <b>{gameId}</b> is now linked to your Argus account.
          </>
        ) : (
          'Your game can now finish signing you in.'
        )
      }
    >
      <Text block>Return to your game. You can close this tab.</Text>
    </PageCard>
  )
}
